import { configureStore } from "@reduxjs/toolkit";
import deleteProject from './FeatureRedux/project/deleteProject'
import counterReducer from './FeatureRedux/testReducer/testReducer'
import getallkml from './FeatureRedux/project/getKmlReducer'
import createBlog from './FeatureRedux/blogs/createblogSlice'
import addCompany from './FeatureRedux/CompanyReducer/addCompany'
import getChartData from './FeatureRedux/chartReducer/donatchartget'
import allcompanylist from './FeatureRedux/CompanyReducer/getCompanylist'
import deleteCompany from './FeatureRedux/CompanyReducer/deleteCompany'
import updateCompany from './FeatureRedux/CompanyReducer/updateCompany'
import getallGraphdata from './FeatureRedux/GraphData/showGraphdata'
import CreateSession from './FeatureRedux/CompanyReducer/loginCompany'
import  addGraphSection  from "./FeatureRedux/GraphData/addGraphSection";
import  getAllprojects  from "./FeatureRedux/project/getAllprojects";
import  addTransportDetail  from "./FeatureRedux/ProjectionReducer/TransportProjectionReducer/addTransport_Projection_reducer";
import  GetTransportDetail  from "./FeatureRedux/ProjectionReducer/TransportProjectionReducer/getTransport_Projection_reducre";
import addNearestInfraSlice from "./FeatureRedux/ProjectionReducer/NearestInfrastructure/addNearestInfrastructure";
import deleteTransportDetail from "./FeatureRedux/ProjectionReducer/TransportProjectionReducer/deleteTransportDetail";
import  addjobgraphland  from "./FeatureRedux/ProjectionReducer/JobgraphlandReducer/jobgraphland";
import  editProjectionGraph  from "./FeatureRedux/ProjectionReducer/TransportProjectionReducer/editProjectionGraph";
import  fetchtodo from "./FeatureRedux/CompanyReducer/TESTREDUCER/todoreducer";//*************** */
import  deletetodo from "./FeatureRedux/CompanyReducer/TESTREDUCER/deletetodo";//***************** */
import  deleteGraph  from "./FeatureRedux/GraphData/deleteGraphSection";
import  Graphupdate  from "./FeatureRedux/GraphData/updateGraphSection";
import  getblog  from "./FeatureRedux/blogs/GetBlogReducer";
import  updateblog  from "./FeatureRedux/blogs/UpdateBlogReducer";
import  deleteblog  from "./FeatureRedux/blogs/DeleteBlogreducer";
import  getAllCity  from "./FeatureRedux/citydetailReducer/getCityDetail";
import  addcity  from "./FeatureRedux/citydetailReducer/Addcity";

const store = configureStore({
  reducer: {
    counter: counterReducer,
    deleteProject:deleteProject,
    getallkml,getallkml,
    createBlog:createBlog,
    addCompany:addCompany,
    getChartData:getChartData,
    allcompanylist:allcompanylist,
    deleteCompany:deleteCompany,
    updateCompany:updateCompany,
    getallGraphdata:getallGraphdata,
    CreateSession:CreateSession,
    addGraphSection:addGraphSection,
    getAllprojects:getAllprojects,
    addTransportDetail:addTransportDetail,
    GetTransportDetail:GetTransportDetail,
    addNearestInfraSlice:addNearestInfraSlice,
    deleteTransportDetail:deleteTransportDetail,
    addjobgraphland:addjobgraphland,
    editProjectionGraph:editProjectionGraph,
    fetchtodo:fetchtodo,
    deletetodo:deletetodo,
    deleteGraph:deleteGraph,
    Graphupdate:Graphupdate,
    getblog:getblog,
    updateblog:updateblog,
    deleteblog:deleteblog,
    getAllCity:getAllCity,
    addcity:addcity,

  },
});

export default store;
